import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { LotList } from '../../../shared/entities/LotList';
import { LoggingService } from '../helper/log.service';
import { QuickSearchResults } from '../../../shared/entities/QuickSearchResults';



const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  })
};

@Injectable()
  export class UserService {
  
    // public userName = '';
    // public userId = 'B44BB1E2-FF6D-E611-98AC-0E22B4A5047B';

    constructor(
        private http: HttpClient,
        private loggingService: LoggingService,
      ) {
    }

}